import InternalLink from './internal-link';

export default InternalLink;
